<template>
  <div class="Polaris-IndexTable__PaginationWrapper">
    <nav
      aria-label="Pagination"
      class="Polaris-Pagination Polaris-Pagination--table"
    >
      <div
        class="Polaris-Box"
        style="--pc-box-background:var(--p-color-bg-surface-secondary);--pc-box-padding-block-start-xs:var(--p-space-150);--pc-box-padding-block-end-xs:var(--p-space-150);--pc-box-padding-inline-start-xs:var(--p-space-300);--pc-box-padding-inline-end-xs:var(--p-space-200)"
      >
        <div
          class="Polaris-InlineStack"
          style="--pc-inline-stack-align:center;--pc-inline-stack-block-align:center;--pc-inline-stack-wrap:wrap;--pc-inline-stack-flex-direction-xs:row"
        >
          <div
            class="Polaris-Pagination__TablePaginationActions"
            data-buttongroup-variant="segmented"
          >
            <div>
              <button
                id="previousURL"
                class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter Polaris-Button--iconOnly"
                :class="{ 'Polaris-Button--disabled': !page.hasPrevPage }"
                aria-label="Previous"
                :aria-disabled="!page.hasPrevPage"
                type="button"
                @click="loadPrevPage"
                :tabindex="page.hasPrevPage ? 0 : -1"
              >
                <span class="Polaris-Button__Icon">
                  <span class="Polaris-Icon">
                    <svg
                      viewBox="0 0 20 20"
                      class="Polaris-Icon__Svg"
                      focusable="false"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M11.764 5.204a.75.75 0 0 1 .032 1.06l-3.516 3.736 3.516 3.736a.75.75 0 1 1-1.092 1.028l-4-4.25a.75.75 0 0 1 0-1.028l4-4.25a.75.75 0 0 1 1.06-.032Z"
                      ></path>
                    </svg>
                  </span>
                </span>
              </button>
            </div>
            <div>
              <button
                id="nextURL"
                class="Polaris-Button Polaris-Button--pressable Polaris-Button--variantSecondary Polaris-Button--sizeMedium Polaris-Button--textAlignCenter Polaris-Button--iconOnly"
                :class="{ 'Polaris-Button--disabled': !page.hasNextPage }"
                aria-label="Next"
                :aria-disabled="!page.hasNextPage"
                type="button"
                @click="loadNextPage"
                :tabindex="page.hasNextPage ? 0 : -1"
              >
                <span class="Polaris-Button__Icon">
                  <span class="Polaris-Icon">
                    <svg
                      viewBox="0 0 20 20"
                      class="Polaris-Icon__Svg"
                      focusable="false"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M7.72 14.53a.75.75 0 0 1 0-1.06l3.47-3.47-3.47-3.47a.75.75 0 0 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0Z"
                      ></path>
                    </svg>
                  </span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    page: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    pagerValue() {
      const page = this.page;
      if (page) {
        if (page.total < page.limit) {
          return page.total;
        }
        if (page.page === 1) {
          return page.limit;
        }
        return page.page * page.limit;
      }
      return 0;
    },
    startingPagerValue() {
      const page = this.page;
      if (page) {
        if (page.page === 1) {
          return 1;
        }
        return (page.page - 1) * page.limit;
      }
      return 1;
    }
  },
  methods: {
    loadNextPage() {
      this.$emit("pageChanged", Number(this.page.page) + 1);
    },
    loadPrevPage() {
      this.$emit("pageChanged", Number(this.page.page) - 1);
    }
  }
};
</script>

<style lang="scss" scoped></style>
